import 'custom-extensions/ui-components/x-image';
import {defineCustomElement} from 'custom-extensions/ui-utils';
import {html, LitElement, nothing} from 'lit';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import stylesheet from './x-content-card-base.scss?as=stylesheet';

export class ContentCardBaseComponent extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			identifier: {
				type: String
			},
			imageUrl: {
				attribute: 'image-url',
				type: String
			},
			name: {
				type: String
			},
			type: {
				type: String
			},
			url: {
				type: String
			}
		};
	}

	constructor () {
		super();

		/**
		 * @type {string}
		 */
		this.identifier = '';

		/**
		 * @type {string}
		 */
		this.imageUrl = '';

		/**
		 * @type {string}
		 */
		this.name = '';

		/**
		 * @type {string}
		 */
		this.type = '';

		/**
		 * @type {string}
		 */
		this.url = '';
	}

	renderImage () {
		return html`
			<div class="image">
				<x-image src="${this.imageUrl}" alt="${this.name} image"></x-image>
			</div>
		`;
	}

	handleClick () {
		// Not implemented
	}

	renderInfoLeft () {
		return this.identifier;
	}

	renderInfoRight () {
		return nothing;
	}

	renderInfo () {
		return html`
			<div class="info-container">
				<div class="name">${unsafeHTML(this.name)}</div>
				<div class="info-bottom">
					<div class="info-left">${this.renderInfoLeft()}</div>
					<div class="info-right">${this.renderInfoRight()}</div>
				</div>
			</div>
		`;
	}

	render () {
		return html`
			<a href="${this.url}" class="container" @click="${this.handleClick}">
				${this.renderImage()}
				${this.renderInfo()}
			</a>
		`;
	}
};

defineCustomElement('x-content-card-base', ContentCardBaseComponent);
